import {ChangeDetectorRef, Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TaskManagementApiService} from '../../task-api.service';
import {EventsApiService} from '../../../events.service';
import {FormGroup, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {EmailsForm} from '../../../emails/components/emails-create/form';
import {Editor, Toolbar} from 'ngx-editor';
import {DialogService} from '../../../../shared/services/dialog.service';
import {LayoutAlertService} from 'src/app/admin/layout-alert.service';

@Component({
    selector: 'app-review-event-cancellation-reason',
    templateUrl: './review-event-cancellation-reason.component.html',
    styleUrls: ['./review-event-cancellation-reason.component.scss'],
    standalone: false
})
export class ReviewEventCancellationReasonComponent implements OnInit {
  title = 'Review event cancellation reason';
  supportedLanguages = [];
  selectedLanguage;
  cancellationReason;
  editor: Editor;
  toolbar: Toolbar = [['bold']];

  editors = {
    // en: { editor: new Editor }
  };

  langTranslations = {
    en: 'English',
    nl: 'Dutch',
  };
  form: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<ReviewEventCancellationReasonComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private taskService: TaskManagementApiService,
    private eventService: EventsApiService,
    private dialogService: DialogService,
    private layoutAlertService: LayoutAlertService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.form = new UntypedFormGroup({});
    this.cancellationReason = this.data.task.related_event.cancellation_reason;
    for (const [language, value] of Object.entries(this.data.task.related_event.cancellation_reason)) {
      this.supportedLanguages.push(language);
      this.editors[language] = new Editor();
      this.form.addControl(language, new UntypedFormControl(this.cancellationReason[language]?.text));
    }
    this.selectedLanguage = this.supportedLanguages[0];
  }

  closeDialog() {
    this.dialogRef.close();
  }

  submitForm() {
    const eventId = this.data.task.related_event.id;
    const payload: any = {cancellation_reason: {}};

    for (const [language, value] of Object.entries(this.form.getRawValue())) {
      payload.cancellation_reason[language] = {text: value};
    }

    this.eventService.updateCancellationReason(eventId, payload).subscribe(
      response => {
        this.createCancellationEvent();
      },
      error => {
        this.layoutAlertService.error(`Error during creating email: ${error.error}`);
      },
    );
  }

  createCancellationEvent() {
    this.taskService.taskAction(this.data.task).subscribe(
      response => {
        this.layoutAlertService.success('Email has been created', 2);
        this.closeDialog();
      },
      error => {
        this.layoutAlertService.error(`Error during creating email: ${error.error}`);
      },
    );
  }

  setSelectedLanguage(languageCode) {
    this.selectedLanguage = languageCode;
    this.cdr.detectChanges();
  }

  protected readonly EmailsForm = EmailsForm;
}
